module.exports = __webpack_public_path__ + "img/sub_support_2.b1772099.png";